import { render } from "./ReadMail.vue?vue&type=template&id=6aafe44e"
import script from "./ReadMail.vue?vue&type=script&lang=js"
export * from "./ReadMail.vue?vue&type=script&lang=js"

import "./ReadMail.vue?vue&type=style&index=0&id=6aafe44e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__